import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PublicTestSummary } from 'modules/test/api';
import * as AuthModule from 'modules/auth';

export const PublicTakeRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const {
    state: { isAuthenticated },
  } = AuthModule.Context.useAuthContext();

  useEffect(() => {
    if (!id) {
      navigate('/', { replace: true });
      return;
    }

    if (isAuthenticated) {
      navigate(`/portal/tests/take/${id}`, { replace: true });
      return;
    }

    let cancelled = false;
    const resolvePublic = async () => {
      try {
        const res = await PublicTestSummary(id);
        if (cancelled) return;
        const token = res.data?.publicLinkToken;
        if (token && res.data.accessType === 'FREE') {
          navigate(`/s/${token}`, { replace: true });
          return;
        }
        navigate(`/login?returnTo=/portal/tests/take/${id}`, { replace: true });
      } catch {
        if (cancelled) return;
        navigate(`/login?returnTo=/portal/tests/take/${id}`, { replace: true });
      }
    };

    resolvePublic();
    return () => { cancelled = true; };
  }, [id, isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-foreground" />
      <p className="mt-3 text-xs font-semibold text-muted-foreground">Imtihon tayyorlanmoqda...</p>
    </div>
  );
};

export default PublicTakeRedirect;
